import { useNavigate, useSearch } from '@tanstack/react-router';

import type { OwnerSortDirection, OwnerSortProperty } from './model';
import { parseOwnersRouteSearch, serializeOwnersRouteSearch } from './ownersRouteSearch';

export function useOwnersRouteFilters() {
  const navigate = useNavigate({ from: '/demand/owners/' });
  const search = useSearch({ from: '/demand/owners/' });
  const filter = parseOwnersRouteSearch(search);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeOwnersRouteSearch(next), replace: true });
  };

  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setSort: (sortProperty: OwnerSortProperty | null, sortDirection: OwnerSortDirection) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
